import React from "react";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import Page from "./Page";
// import NoPage from "./pages/NoPage"; // TODO (kyle): Reroute no-page to home

function App() {
  return (
    <BrowserRouter>
      <Page />
      {/* <Routes>
        <Route path="/" element={<Page />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes> */}
    </BrowserRouter>
  );
}

export default App;
